<div class="outlet-container topBanner">
    <div class="banner">
        <div class="bannerText">
            <div>
                <h1 class="font-extrabold bannerTitle">1000+ Offers in Malta & Gozo</h1>
                <h3 class="bannerSubtitle">on fashion, home, restaurants, healthy eateries, gyms, spas, toy shops, home decor, pet shops & more!</h3>
            </div>
            <img class="banner-image-sm" [src]="selectedBanner"/>
            <div class="store-ctas">
                <a target="_blank" rel="noreferrer" routerLink="/android">
                    <img src="old/playstore-btn.png" alt="Get cloudigo on the playstore"/>
                </a>
                <a target="_blank" rel="noreferrer" routerLink="/ios">
                    <img src="old/appstore-btn.png" alt="Get cloudigo on the appstore"/>
                </a>
            </div>
            <button class="homeButton" routerLink="/get-the-app">
                <mat-icon>chevron_right</mat-icon>
                <span class="font-semibold">Download free app</span>
                <mat-icon>chevron_left</mat-icon>
            </button>
        </div>
        <div class="banner-image">
            <img class="bannerImg" [src]="selectedBanner"/>
        </div>
    </div>
</div>
<a class="underBanner premium-horizontal no-decoration f-main-center f-cross-center py-10 px-24 p-inset cgap-16" routerLink="/premium">
    <span id="underText">See how you can save more with Premium</span>
    <mat-icon aria-hidden="false" class="ml-4">arrow_right_alt</mat-icon>
</a>